// ============================================================================
// 📁 File: DrawingKpiCards.jsx
// 🧭 Module: PPE → Engineering → Drawing
// 📝 Purpose:
//   - KPI cards for Drawing Master
//   - Shows Total / Draft / Released / Obsolete
// ============================================================================

import React from "react";
import { Card, Row, Col } from "antd";
import {
  FileTextOutlined,
  EditOutlined,
  CheckCircleOutlined,
  StopOutlined,
} from "@ant-design/icons";

// ============================================================================
// COMPONENT
// ============================================================================

const DrawingKpiCards = ({ data = {} }) => {
  const {
    total = 0,
    draft = 0,
    released = 0,
    obsolete = 0,
  } = data;

  const cards = [
    {
      title: "Total Drawings",
      value: total,
      icon: <FileTextOutlined />,
      color: "#1677ff",
    },
    {
      title: "Draft",
      value: draft,
      icon: <EditOutlined />,
      color: "#faad14",
    },
    {
      title: "Released",
      value: released,
      icon: <CheckCircleOutlined />,
      color: "#52c41a",
    },
    {
      title: "Obsolete",
      value: obsolete,
      icon: <StopOutlined />,
      color: "#ff4d4f",
    },
  ];

  return (
    <Row gutter={16} style={{ marginBottom: 16 }}>
      {cards.map((c) => (
        <Col xs={24} sm={12} md={6} key={c.title}>
          <Card bordered>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 16,
              }}
            >
              <div
                style={{
                  fontSize: 26,
                  color: c.color,
                }}
              >
                {c.icon}
              </div>

              <div>
                <div
                  style={{
                    fontSize: 13,
                    color: "#888",
                  }}
                >
                  {c.title}
                </div>
                <div
                  style={{
                    fontSize: 22,
                    fontWeight: 600,
                  }}
                >
                  {c.value}
                </div>
              </div>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default DrawingKpiCards;
